import useEditAdditional, {
  EditAdditionalProps,
} from 'modules/additionals/hooks/use-edit-additional';
import {translatedAdditionalProps} from 'modules/additionals/types';
import additionalsKeys from 'modules/additionals/util/additionals-keys';
import React from 'react';
import {useParams} from 'react-router-dom';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';

const EditAdditional: React.FC = () => {
  const {additionalId} = useParams();
  const {getInput, getSwitch, getTextArea, getPriceInput, getImagePicker} =
    useFormInputs<EditAdditionalProps>();

  const handleSubmit = (additional: EditAdditionalProps) => {
    const formData = new FormData();

    formData.append('name', additional.name);
    formData.append('description', additional.description ?? '');
    formData.append('price', String(additional.price));
    formData.append('active', String(additional.active));
    formData.append('additionalGroupId', additional.additionalGroupId);
    if (additional.image && (additional.image as any) instanceof File)
      formData.append('image', additional.image);

    return formData;
  };

  return (
    <Edition<EditAdditionalProps>
      titleBar={{title: 'Editar adicional'}}
      handleSubmit={handleSubmit}
      inputs={[
        getInput({
          name: 'name',
        }),
        getTextArea({name: 'description'}),
        getSwitch({
          name: 'active',
        }),
        getPriceInput({name: 'price'}),
        getImagePicker({name: 'image', label: 'Imagem'}),
      ]}
      detailsUrl={`/additionals/${additionalId}`}
      onSubmit={() => useEditAdditional(additionalId!)}
      translationKey={translatedAdditionalProps}
      queryKey={additionalsKeys.details(additionalId!)}
    />
  );
};

export default EditAdditional;
